import { Client } from '@/common/services/Client';

interface AddRenewalNoteRequest {
  content: string;
}

export async function addRenewalNote(
  renewalUuid: string,
  content: string,
): Promise<void> {
  const response = await Client.post<void, AddRenewalNoteRequest>({
    body: {
      content: content,
    },
    endpoint: `/renewals/${renewalUuid}/note`,
  });
  return response.data;
}
